import React, { useState, useEffect } from 'react';

const AnnouncementBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    // Check if banner was dismissed in this session
    const dismissed = sessionStorage.getItem('heic-banner-dismissed');
    if (!dismissed) {
      // Show banner after a short delay for dramatic effect
      setTimeout(() => {
        setIsVisible(true);
        setIsAnimating(true);
      }, 500);
    }
  }, []);

  const handleDismiss = () => {
    setIsAnimating(false);
    setTimeout(() => {
      setIsVisible(false);
      sessionStorage.setItem('heic-banner-dismissed', 'true');
    }, 300);
  };

  if (!isVisible) return null;

  return (
    <div
      className={`fixed top-20 left-1/2 transform -translate-x-1/2 z-40 transition-all duration-300 ${
        isAnimating ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'
      }`}
      style={{ maxWidth: '90vw', width: '600px' }}
    >
      <div className="bg-gradient-to-r from-brand-primary to-purple-600 rounded-lg shadow-2xl p-4 relative overflow-hidden">
        {/* Animated background sparkles */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-2 left-4 w-2 h-2 bg-white rounded-full animate-ping opacity-75"></div>
          <div className="absolute top-4 right-8 w-1.5 h-1.5 bg-yellow-300 rounded-full animate-ping opacity-75" style={{ animationDelay: '0.3s' }}></div>
          <div className="absolute bottom-3 left-12 w-1 h-1 bg-white rounded-full animate-ping opacity-75" style={{ animationDelay: '0.6s' }}></div>
        </div>

        {/* Close button */}
        <button
          onClick={handleDismiss}
          className="absolute top-2 right-2 text-white/70 hover:text-white transition-colors z-10"
          aria-label="Close"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {/* Content */}
        <div className="flex items-center gap-4 relative z-10">
          {/* Icon */}
          <div className="flex-shrink-0">
            <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center backdrop-blur-sm">
              <span className="text-2xl">🎉</span>
            </div>
          </div>

          {/* Text */}
          <div className="flex-1">
            <h3 className="text-white font-bold text-lg leading-tight mb-1">
              NEW: HEIC Support is Live!
            </h3>
            <p className="text-white/90 text-sm">
              Now convert iPhone photos (HEIC) to JPG/PNG instantly
            </p>
          </div>

          {/* Badge */}
          <div className="flex-shrink-0 hidden sm:block">
            <span className="bg-white text-brand-primary text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wide shadow-lg">
              New
            </span>
          </div>
        </div>

        {/* Optional: Confetti effect border */}
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-yellow-400 via-pink-400 to-purple-400"></div>
      </div>
    </div>
  );
};

export default AnnouncementBanner;

